// Migrated from Contentful to Strapi
import strapiClient from './strapiClient';

// Export the Strapi client with Contentful-compatible interface
const client = strapiClient;

export default client;